import { Fetch } from 'lib';
import type { Role } from 'types';

type RequestResponses = Role;

type RequestParameters = {};

type RequestBody = StrictOmit<Role, 'id'>;

const createRole = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminRole/createRole',
    method: 'POST',
    body,
  });

export { createRole };
